
import _ from 'underscore';

const fieldData = {
    methods: {
        makeField(obj) {
            var params = {
                label: '',
                id: 'field',
                name: 'field',
                type: 'text',
                dValue: '',
                cssClass: '',
                placeholder: '',
                required: '',
                allow_clear: true,
                confirm_on_delete: false,
                groupClass: '',
                mask: '',
                filters: [],
                cssFormControl: true,
                options: [],
                rows: 3,
                ajax: '',
                multiple: false,
                allowed_ext: '',
                can_delete: true,
                fieldset: true,
                showPlaceholder: true,
                description: '',
                reset: false
            }
            obj.id = obj.id ?? obj.name
            _.extend(params, obj)
    
            return params;
        }
    }   
}
export default fieldData 